import { render, staticRenderFns } from "./Assinar.vue?vue&type=template&id=1874c262&scoped=true&"
import script from "./Assinar.vue?vue&type=script&lang=js&"
export * from "./Assinar.vue?vue&type=script&lang=js&"
import style0 from "./Assinar.vue?vue&type=style&index=0&id=1874c262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874c262",
  null
  
)

export default component.exports